import { useApi } from './use-api-call';
import { BoardDTO } from './board-api';
import { CustomerDTO } from './customer-api';

export const useSearchContractApi = () =>
    useApi<{
        contracts: ContractDTO[];
        boards: BoardDTO[];
        customers: CustomerDTO[];
        allowEdit: boolean;
    }>('/contract/search-contract');

export const useExpiringContractApi = () =>
    useApi<{
        expiringContracts: ExpiringContractDTO[];
        now: Date;
    }>('/contract/expiring-contract');

export const useGetContractApi = () =>
    useApi<{ contract: ContractDTO; allowEdit: boolean }>('/contract/get-contract/{id}');

export const useSaveContractApi = () =>
    useApi<{ contract: ContractDTO }>('/contract/save-contract');

export const useDeleteContractApi = () => useApi('/contract/delete-contract/{id}');

export interface ExpiringContractDTO {
    id: number;
    customerName: string;
    companyName?: string;
    boardTitle: string;
    startDate: Date;
    endDate: Date;
}
export interface ContractDTO {
    id?: number;
    boardId: number;
    customerId: number;
    startDate: Date;
    endDate: Date;
    price: number;
    createdAt?: Date;
    createdBy?: string;
    modifiedAt?: Date;
    modifiedBy?: string;
}
